import React from 'react'

import { FadeIn } from '@pb/components'

import styles from './Loader.scss'

const Loader: React.FC = () => (
  <FadeIn className={styles.container}>
    <div className={styles.title} />
    <div className={styles.title} />

    <div className={styles.list}>
      <div className={styles.item}>
        <div className={styles.image} />
        <div className={styles.info}>
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
      <div className={styles.item}>
        <div className={styles.image} />
        <div className={styles.info}>
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
      <div className={styles.item}>
        <div className={styles.image} />
        <div className={styles.info}>
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    </div>
  </FadeIn>
)

export default Loader
